import script from "./attachment-list-item-actions.vue?vue&type=script&setup=true&lang=ts"
export * from "./attachment-list-item-actions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__